const en = {
  // HttpClient
  'error.mustLogIn': 'You must log in',
  'error.somethingWentWrong': 'Something went wrong, please try again',

  // Modal
  'modal.close': 'Close',

  // Login
  'login.heading': 'Enter your email to log in',
  'login.emailLabel': 'Email',
  'login.emailPlaceholder': 'example@email.com',
  'login.submitSending': 'Sending...',
  'login.submitButton': 'Send login link',
  'login.signUpLink': 'Sign up',
  'login.support': 'Need help?',
  'login.error': 'An error occurred',

  // SignUp
  'signUp.heading': 'Sign up',
  'signUp.mobileWarningTitle': 'IMPORTANT',
  'signUp.mobileWarningHeading': 'Use a computer',
  'signUp.mobileWarningText':
    '{appName} is designed to work on a computer. Sign up here and log in on your computer to use the app.',
  'signUp.nameLabel': 'Name',
  'signUp.namePlaceholder': 'First Last',
  'signUp.emailLabel': 'Email',
  'signUp.emailPlaceholder': 'example@email.com',
  'signUp.termsCheckbox': "I accept {appName}'s",
  'signUp.termsLink': 'terms of service',
  'signUp.marketingCheckbox':
    'I agree to receive emails with information and offers from {domain}',
  'signUp.submitRegistering': 'Registering...',
  'signUp.submitButton': 'Register',
  'signUp.signInLink': 'Log in',
  'signUp.support': 'Need help?',
  'signUp.successToast': 'You are now registered at {domain}',
  'signUp.error': 'An error occurred',

  // Projects
  'projects.title': 'My drawings',
  'projects.promoText': 'Draw as much as you want',
  'projects.promoSubtext': 'Create unlimited drawings and export to .pdf',
  'projects.promoPrice': '49 SEK/month (enter promo code RITABYGGLOV50)',
  'projects.upgradeButton': 'Subscribe',
  'projects.newProjectFirstTime': 'Create your first drawing',
  'projects.newProject': 'Create new drawing',
  'projects.subscribeToCreateMore': 'Subscribe to create more drawings',
  'projects.newProjectButton': '+ New drawing',
  'projects.createdAt': 'Created {date}',
  'projects.updatedAt': 'Updated {date}',
  'projects.scaleAndFormat': '{scale}, {format}',
  'projects.viewButton': 'View',
  'projects.editButton': 'Edit',
  'projects.copyButton': 'Copy',
  'projects.deleteButton': 'Delete',
  'projects.showAsList': 'Show as list',
  'projects.showAsCards': 'Show as cards',
  'projects.moreActions': 'More actions',

  // CookieBanner
  'cookieBanner.title': 'Third-party cookies',
  'cookieBanner.text':
    '{appName} collects data from users to improve the service. Data is collected via third parties and is never shared with or sold to other companies. The purpose is solely to develop the service.',
  'cookieBanner.accept': 'Accept',
  'cookieBanner.reject': 'Reject',
  'cookieBanner.readMore': 'Read more in our',
  'cookieBanner.termsLink': 'terms of service',

  // PSABanner
  'psaBanner.message':
    'Technical problems at one of our service providers causes incorrect formats when exporting to PDF. Work to resolve the issue is ongoing.',

  // ErrorFallback
  'error.title': 'Something went wrong',
  'error.description':
    'We encountered an unexpected error. Your work is safe and we have been notified of the problem. Try reloading the page.',
  'error.contactInfo': 'If the problem persists, please contact support at',
  'error.reloadButton': 'Reload page',
  'error.retryButton': 'Try again',

  // UserSettings
  'userSettings.title': 'Account settings',
  'userSettings.backLink': '\u2190 Back',
  'userSettings.accountInfo': 'Account information',
  'userSettings.memberSince': 'Member since {date}',
  'userSettings.subscription': 'Subscription',
  'userSettings.subscriptionStatus': 'Your subscription is: {status}',
  'userSettings.subscriptionActive': 'Active',
  'userSettings.subscriptionTrialing': 'Trial',
  'userSettings.subscriptionCancelsAt': 'Cancels: {date}',
  'userSettings.subscriptionRenewsAt': 'Next renewal: {date}',
  'userSettings.noNoticeperiod': '{appName} has no notice period.',
  'userSettings.pastSubscriptions': 'Past subscriptions',
  'userSettings.pastSubscriptionRow': '{start} \u2013 {end} ({status})',
  'userSettings.pastSubscriptionCanceled': 'Canceled',
  'userSettings.manageSubscription': 'Manage',
  'userSettings.cookieConsent': 'Analytics cookies',
  'userSettings.cookieConsentDescription':
    '{appName} uses optional cookies to improve the product. Choose whether to accept or disable them here. Read more in our <termsLink>terms of service</termsLink>.',
  'userSettings.disableCookies': 'Disable',
  'userSettings.enableCookies': 'Enable',
  'userSettings.cookiesDisabledToast': 'Analytics cookies have been disabled.',
  'userSettings.cookiesEnabledToast': 'Analytics cookies have been enabled.',
  'userSettings.marketingConsent': 'Marketing consent',
  'userSettings.marketingConsentDescription':
    '{appName} sends emails to users who have consented to receive them.',
  'userSettings.marketingConsentEnabled':
    'You are now receiving marketing emails.',
  'userSettings.marketingConsentDisabled':
    'Your marketing consent has been revoked.',
  'userSettings.revokeMarketing': 'Revoke',
  'userSettings.approveMarketing': 'Approve',
  'userSettings.deleteAccount': 'Delete account',
  'userSettings.deleteAccountDescription':
    'Delete your account, all drawings, and all data we have stored about you. This cannot be undone.',
  'userSettings.deleteConfirmPrompt': 'Type {phrase} to confirm:',
  'userSettings.confirmDeleteButton': 'Confirm deletion',
  'userSettings.cancelButton': 'Cancel',
  'userSettings.deleteButton': 'Delete',
  'userSettings.support': 'Questions? Contact us at {contactEmail}',
  'userSettings.activeSubscriptionNotice':
    'You have an active subscription. Cancel it before deleting your account.',
  'userSettings.language': 'Language',
  'userSettings.languageDescription':
    'Choose which language you want to use in the application.',

  // Navbar
  'navbar.adminLabel': 'Admin:',
  'navbar.adminStart': 'Start',
  'navbar.adminProjects': 'Projects',
  'navbar.adminUsers': 'Users',
  'navbar.loggedInAs': 'Logged in as: {name}',
  'navbar.signOut': 'Log out',
  'navbar.accountSettings': 'Account settings',

  // Export
  'export.subscribeButton': 'Subscribe',
  'export.exportButton': 'Export to PDF',
  'export.successToast': 'Your drawing has been exported',
  'export.errorToast': 'Something went wrong during export',

  // ExportDialog
  'exportDialog.heading': 'Export drawing to PDF',
  'exportDialog.drawingHeadSection': 'Title block',
  'exportDialog.drawingHeadInfo':
    'This information will appear on the drawing when exported',
  'exportDialog.authorLabel': 'Name / Org. number',
  'exportDialog.authorPlaceholder': 'Name / Org. number',
  'exportDialog.dateLabel': 'Drawing date',
  'exportDialog.datePlaceholder': 'Date of drawing',
  'exportDialog.propertyLabel': 'Property reference',
  'exportDialog.propertyPlaceholder': 'Property reference',
  'exportDialog.formatSection': 'Drawing format',
  'exportDialog.scaleLabel': 'Scale',
  'exportDialog.scalePlaceholder': 'Scale',
  'exportDialog.submitButton': 'Export to PDF',

  // NorthArrow
  'northArrow.hiddenToast': 'North arrow hidden. Show again in settings.',
  'northArrow.hideButton': 'Hide north arrow',

  // TitleBlock
  'titleBlock.hiddenToast': 'Title block hidden. Show again in settings.',
  'titleBlock.hideButton': 'Hide title block',
  'titleBlock.fields.name': 'Drawing name',
  'titleBlock.fields.drawingType': 'Drawing type',
  'titleBlock.fields.propertyReference': 'Property reference',
  'titleBlock.fields.author': 'Drawn by',
  'titleBlock.fields.date': 'Date',
  'titleBlock.fields.projectName': 'Project name',
  'titleBlock.fields.propertyDesignation': 'Property designation',
  'titleBlock.fields.yourName': 'Your name',
  'titleBlock.formatAndScale': 'Format: {format} | Scale: {scale}',
  'titleBlock.createdWith': 'Created with {appName}',

  // RenderMap
  'renderMap.formatWarning':
    'Warning: The imported map format does not match the drawing format. Change the drawing format in the settings menu, or upload a new map.',

  // PolylineDimensions
  'polylineDimensions.flipSide': 'Click to flip side',

  // ResizeHandlers
  'resizeHandlers.radiusLabel': 'Radius {radius}',

  // Checklist
  'checklist.hideButton': 'Hide checklist',
  'checklist.showButton': 'Show checklist',
  'checklist.readMore': '(read more)',

  // MobilePopup
  'mobilePopup.title': '{appName} requires a mouse and keyboard to work',
  'mobilePopup.messageLine1':
    '{appName} requires a mouse & keyboard. Touch screens on tablets and mobile phones are not currently supported.',
  'mobilePopup.messageLine2': 'Log in on a computer to use {appName}.',
  'mobilePopup.closeButton': 'OK',

  // Watermark
  'watermark.text': 'Subscribe to remove the watermark',

  // Toasts (component)
  'toast.closeButton': 'close',
  'canvas.copyToast':
    '{count, plural, one {# element copied} other {# elements copied}}',

  // TopMenu
  'topMenu.mapAndScale': 'Map and scale',
  'topMenu.syncSaved': 'All changes saved',
  'topMenu.syncSaving': 'Saving changes...',
  'topMenu.syncUnsaved': '{count} unsaved changes \u2013 trying to reconnect',
  'localStorageWarning.title': 'Local storage is disabled',
  'localStorageWarning.body':
    'Your browser has disabled local storage. This means changes may be lost if you close this tab before they sync to the server. Enable cookies and local storage in your browser settings to ensure your work is saved.',
  'localStorageWarning.linkText': 'Learn how to enable local storage',
  'topMenu.syncStalled':
    'Your changes are not syncing – check your connection.',

  // Settings (canvas settings panel)
  'settings.importMapTitle': 'Import map',
  'settings.importMapText':
    'Upload a map in pdf, png or jpeg format for your drawing. File size: max 10 MB.',
  'settings.importMapReadMore': 'Read more about imports',
  'settings.currentFile': 'Selected file: {filename}',
  'settings.deleteFile': 'Delete',
  'settings.unitSystemTitle': 'Unit system',
  'settings.unitSystemText':
    'The measurement units for dimensions, scales and page sizes in this drawing',
  'settings.unitSystemMetric': 'Metric',
  'settings.unitSystemImperial': 'Imperial',
  'settings.lengthFormatMeters': 'Meters (5.05 m)',
  'settings.lengthFormatMillimeters': 'Millimeters (5050 mm)',
  'settings.lengthFormatFeetInches': 'Feet & inches (24\'-6")',
  'settings.lengthFormatDecimalFeet': 'Decimal feet (24.5 ft)',
  'settings.scaleTitle': 'Drawing scale',
  'settings.scaleText': 'The scale for this drawing document',
  'settings.scaleReadMore': 'Read more about scale',
  'settings.formatTitle': 'Drawing format',
  'settings.formatText': 'The format for this drawing document',
  'settings.titleBlockSectionTitle': 'Title block',
  'settings.titleBlockSectionText':
    'Choose whether the title block and north arrow should be shown on the drawing',
  'settings.northArrowLabel': 'North arrow',
  'settings.titleBlockLabel': 'Title block',
  'settings.uploadSuccess': 'Your map has been updated.',
  'settings.uploadError': 'Failed to add map',

  'pdfPagePicker.title': 'Select page to import',
  'pdfPagePicker.page': 'Page {page}',
  'pdfPagePicker.rotateLeft': '↺ Rotate counterclockwise',
  'pdfPagePicker.rotateRight': '↻ Rotate clockwise',
  'pdfPagePicker.import': 'Import',
  'pdfPagePicker.importing': 'Importing...',
  'pdfPagePicker.back': 'Back',

  // Page formats
  'format.groupInternational': 'International (ISO)',
  'format.groupUS': 'US',
  'format.A3_LANDSCAPE': 'A3 Landscape',
  'format.A3_PORTRAIT': 'A3 Portrait',
  'format.A4_LANDSCAPE': 'A4 Landscape',
  'format.A4_PORTRAIT': 'A4 Portrait',
  'format.LETTER_LANDSCAPE': 'Letter Landscape',
  'format.LETTER_PORTRAIT': 'Letter Portrait',
  'format.TABLOID_LANDSCAPE': 'Tabloid Landscape',
  'format.TABLOID_PORTRAIT': 'Tabloid Portrait',
  'format.ARCH_C_LANDSCAPE': 'Arch C Landscape',
  'format.ARCH_C_PORTRAIT': 'Arch C Portrait',
  'format.ARCH_D_LANDSCAPE': 'Arch D Landscape',
  'format.ARCH_D_PORTRAIT': 'Arch D Portrait',
  'format.short.A3': 'A3',
  'format.short.A4': 'A4',
  'format.short.LETTER': 'Letter',
  'format.short.TABLOID': 'Tabloid',
  'format.short.ARCH_C': 'Arch C',
  'format.short.ARCH_D': 'Arch D',

  // Toolbar
  'toolbar.pan': 'Pan',
  'toolbar.select': 'Select',
  'toolbar.text': 'Text',
  'toolbar.line': 'Line',
  'toolbar.rect': 'Rectangle',
  'toolbar.dimension': 'Dimension',
  'toolbar.perpendicularGuide': 'Perpendicular guide',
  'toolbar.showAngles': 'Show angles',
  'toolbar.addElement': 'Add',
  'toolbar.endLine': 'End line',
  'toolbar.contextPanSpace': 'Click and drag to pan.',
  'toolbar.contextPanTip': 'Tip: You can also pan by holding the spacebar.',
  'toolbar.contextAddRect': 'Click to add a rectangle.',
  'toolbar.contextAddText': 'Click to add a text box.',
  'toolbar.contextAddPolylineFirst': 'Place the start point of the line.',
  'toolbar.contextAddPolyline':
    'Add more points by clicking. Press Escape to finish.',
  'toolbar.contextAddDimensionFirst':
    'Click multiple times to add dimension lines.',
  'toolbar.contextEditPolyline': 'Tip: Drag the blue handles to edit the line.',
  'toolbar.contextEditText':
    'Double click to edit the text. Press Escape to deselect.',
  'toolbar.contextEditingText': 'Type in the box. Press Escape to deselect.',
  'toolbar.contextSelect': 'Select a tool to add a new object.',
  'toolbar.symbolTriangle': 'Triangle',
  'toolbar.symbolTrapezoid': 'Trapezoid',
  'toolbar.symbolAngle': 'Angle',
  'toolbar.symbolGeneralWell': 'Well (general symbol)',
  'toolbar.symbolWell': 'Well',
  'toolbar.symbolDrillHole': 'Drill hole',
  'toolbar.symbolThreeChamberWell': 'Three-chamber well',
  'toolbar.fixtureWindowPlan': 'Window (plan)',
  'toolbar.fixtureWindowElevation': 'Window (elevation)',
  'toolbar.fixtureWindowElevationOpenable': 'Openable window (elevation)',
  'toolbar.fixtureDoorPlan': 'Door (plan)',
  'toolbar.fixtureDoorElevation': 'Door (elevation)',
  'toolbar.fixtureDoubleDoorPlan': 'Double door (plan)',
  'toolbar.fixtureDoubleDoorElevation': 'Double door (elevation)',
  'toolbar.fixtureSlidingDoorPlan': 'Sliding door (plan)',
  'toolbar.fixtureSlidingDoorElevation': 'Sliding door (elevation)',
  'toolbar.fixtureRoofAngle': 'Roof pitch',
  'toolbar.fixtureStraightStairPlan': 'Straight stair',
  'toolbar.fixtureDoubleStairPlan': 'Double flight stair',
  'toolbar.fixtureCornerStairPlan': 'L-shaped stair',
  'toolbar.fixtureUStairPlan': 'U-shaped stair',
  'toolbar.presetWaterClosetPlan': 'Water closet',
  'toolbar.presetSinkPlan': 'Sink',
  'toolbar.presetBathTubPlan': 'Bath tub',
  'toolbar.presetChairPlan': 'Chair',
  'toolbar.presetTableAndChairsPlan': 'Table and chairs',

  // Controls / PropertyGroups
  'controls.widthAndHeight': 'Width and height',
  'controls.dimensions': 'Dimensions',
  'controls.height': 'Height',
  'controls.alignLeft': 'Left aligned',
  'controls.alignCenter': 'Centered',
  'controls.alignRight': 'Right aligned',
  'controls.mirrorHorizontal': 'Mirror horizontally',
  'controls.mirrorVertical': 'Mirror vertically',
  'controls.patternNone': 'No pattern',
  'controls.patternWhiteFill': 'White fill',
  'controls.patternDiagonalHatch': 'Diagonal hatch',
  'controls.patternDots': 'Dots',
  'controls.patternBrick1': 'Brick 1',
  'controls.patternBrick2': 'Brick 2',
  'controls.patternRoofTiles': 'Roof tiles',
  'controls.patternVerticalWood': 'Vertical wood panel',
  'controls.patternHorizontalWood': 'Horizontal wood panel',
  'controls.patternSizeSmall': 'Small pattern size',
  'controls.patternSizeMedium': 'Medium pattern size',
  'controls.patternSizeLarge': 'Large pattern size',
  'controls.patternDarkGrey': 'Dark grey',
  'controls.patternLightGrey': 'Light grey',
  'controls.patternBlack': 'Black',
  'controls.patternRed': 'Red',
  'controls.patternOrange': 'Orange',
  'controls.patternYellow': 'Yellow',
  'controls.patternGreen': 'Green',
  'controls.patternBlue': 'Blue',
  'controls.patternTitle': 'Pattern',
  'controls.textColorTitle': 'Text color',
  'controls.strokeColorTitle': 'Line color',
  'controls.strokeColorNone': 'No line color',
  'controls.strokeTitle': 'Line settings',
  'controls.dimensionsTitle': 'Dimensions',
  'controls.smallDimensions': 'Small dimensions',
  'controls.largeDimensions': 'Largest dimensions',
  'controls.strokeSmall': 'Small width',
  'controls.strokeLarge': 'Larger width',
  'controls.rotation': 'Rotation',
  'controls.fontSize': 'Font size',
  'controls.textAlign': 'Text alignment',
  'controls.width': 'Width',
  'controls.length': 'Length',
  'controls.showAllSegments': 'Show all lengths',
  'controls.pointRatio': 'Apex position',
  'controls.reorderTitle': 'Change order',
  'controls.moveToTop': 'Move to top',
  'controls.moveUp': 'Move up',
  'controls.moveDown': 'Move down',
  'controls.moveToBottom': 'Move to bottom',
  'controls.deleteButton': 'Delete',
  'controls.copyButton': 'Copy',
  'controls.groupButton': 'Group',
  'controls.groupButtonTitle': 'Group these elements (CTRL + G)',
  'controls.ungroupButton': 'Ungroup',
  'controls.ungroupButtonTitle': 'Ungroup these elements (CTRL + SHIFT + G)',
  'controls.strokeWidthThin': 'Thin line',
  'controls.strokeWidthMedium': 'Medium line',
  'controls.strokeWidthThick': 'Thick line',
  'controls.strokeWidthExtraThick': 'Extra thick line',
  'controls.thicknessExact': 'Exact thickness in metres',
  'controls.thicknessExactMillimeters': 'Exact thickness in millimetres',
  'controls.thicknessExactImperial': 'Exact thickness in inches',
  'controls.polylineStrokeWidthSmall': 'Small width',
  'controls.polylineStrokeWidthMedium': 'Medium width',
  'controls.fontSizeSmall': 'Small text',
  'controls.fontSizeMedium': 'Medium text',
  'controls.fontSizeLarge': 'Large text',
  'controls.fontSizeExtraLarge': 'Extra large text',
  'controls.dimensionNone': 'No dimensions',
  'controls.dimensionMedium': 'Medium dimensions',
  'controls.dimensionLarge': 'Large dimensions',
  'controls.strokeDashSolid': 'Solid line',
  'controls.strokeDashDotted': 'Dotted line',
  'controls.strokeDashDashed': 'Dashed line',
  'controls.strokeDashDotDashed': 'Dot-dashed line',
  'controls.strokeDashOutlined': 'Outlined',
  'controls.strokeDashDashedAlt': 'Alternative dashed line',

  // New Project Modal
  'newProject.title': 'New drawing',
  'newProject.subtitle': 'Create a new drawing in A3 or A4 format',
  'newProject.nameLabel': 'Drawing name',
  'newProject.typeLabel': 'Drawing type',
  'newProject.unitSystemLabel': 'Unit system',
  'newProject.scaleLabel': 'Drawing scale',
  'newProject.scaleHint': 'You can change the scale later.',
  'newProject.scaleReadMore': 'Read more about scale and which to choose',
  'newProject.formatLabel': 'Drawing format',
  'newProject.formatHint': 'The format should match any map you plan to import',
  'newProject.submitButton': 'Create drawing',
  'newProject.submittingButton': 'Creating drawing...',
  'newProject.comingSoon': 'Coming soon',
  'drawingType.sitePlan': 'Site plan',
  'drawingType.sitePlanText': 'Shows the plot of land in question.',
  'drawingType.facadeDrawing': 'Facade drawing',
  'drawingType.facadeDrawingText':
    'Shows the facades of the building in a front view.',
  'drawingType.other': 'Blank drawing',
  'drawingType.otherText': 'Draw freely without a template or checklist.',
  'drawingType.floorPlan': 'Floor plan',
  'drawingType.floorPlanText': 'Top-down view with included elements.',
  'scaleDescription.1:1000': 'For overview maps and large areas',
  'scaleDescription.1:800': 'For larger site plans',
  'scaleDescription.1:500': 'Common for site plans',
  'scaleDescription.1:400': 'Common for site plans',
  'scaleDescription.1:250': 'Good for smaller site plans',
  'scaleDescription.1:200': 'For floor and facade drawings',
  'scaleDescription.1:100': 'For floor and facade drawings',
  'scaleDescription.1:50': 'For detailed floor and facade drawings',

  // Delete Project Modal
  'deleteProject.title': 'Delete drawing',
  'deleteProject.confirm': 'Are you sure you want to delete this drawing?',
  'deleteProject.yes': 'Yes, delete',
  'deleteProject.no': 'Cancel',
  'deleteProject.loading': 'Deleting drawing',

  // Edit Project Modal
  'editProject.title': 'Edit drawing',
  'editProject.nameLabel': 'Name',
  'editProject.scaleLabel': 'Drawing scale',
  'editProject.scaleHint': 'Which scale is right?',
  'editProject.scaleReadMore': 'Read more',
  'editProject.formatLabel': 'Drawing format',
  'editProject.submitButton': 'Save',
  'editProject.submittingButton': 'Saving...',

  // Copy Project Modal
  'copyProject.title': 'Copy drawing',
  'copyProject.confirm': 'Do you want to copy {name}?',
  'copyProject.description':
    'A new drawing will be created with all changes and the checklist.',
  'copyProject.submitButton': 'Yes, copy',
  'copyProject.loading': 'Copying drawing',
  'copyProject.cancelButton': 'Cancel',

  // Subscription Modal
  'subscription.monthly': 'Monthly',
  'subscription.yearly': 'Yearly',
  'subscription.perMonth': '/ month',
  'subscription.perYear': '/ year',
  'subscription.discount': '(-{percent}%)',
  'subscription.selectButton': 'Select',
  'subscription.paymentLine1': 'Payment securely via Stripe.',
  'subscription.paymentLine2': 'No commitment, cancel anytime.',
  'subscription.paymentLine3': 'Read our',
  'subscription.paymentTermsLink': 'terms of service',
  'subscription.removeWatermarkDescription':
    'Subscribe to remove the watermark and export your drawings to PDF.',
  'subscription.questionsContact':
    'Questions about subscriptions? Contact us at {contactEmail}',
  'subscription.noUrlError': 'No URL received from server',
  'subscription.errorToast': 'Something went wrong with the subscription',

  // Subscription Cancel
  'subscriptionCancel.title': 'Subscription cancelled',
  'subscriptionCancel.message':
    'You have cancelled the process of starting a subscription. You are always welcome to subscribe in the future!',
  'subscriptionCancel.goHome': 'Go to home page',

  // Subscription Success
  'subscriptionSuccess.title': 'Subscription activated!',
  'subscriptionSuccess.text1': 'You now have access to subscription features.',
  'subscriptionSuccess.text2': 'For questions, contact us at {contactEmail}.',
  'subscriptionSuccess.text3':
    'We who founded {appName} read and reply to all emails. We would love to hear what you think, and how your project is going.',
  'subscriptionSuccess.text4':
    'Your subscription renews automatically. To cancel, go to "Account Settings" and click "Manage" under the subscription section.',
  'subscriptionSuccess.goHome': 'Go to home page',

  // Subscription Management Link
  'subscriptionLink.manage': 'Manage subscription',
  'subscriptionLink.expiresAt': 'Current subscription expires {date}',

  // Plans
  'plans.free.title': 'Free',
  'plans.free.description':
    'Try what {appName} is capable of without paying anything.',
  'plans.regular.title': 'Subscription',
  'plans.regular.description':
    'Import maps, create site plans, relation drawings, or simple facade drawings directly in the browser.',
  'plans.professional.title': 'Professional',
  'plans.professional.description':
    'Import maps, create site plans, relation drawings, or simple facade drawings directly in the browser.',
  'plans.feature.unlimitedDrawings': 'Unlimited drawings',
  'plans.feature.exportPdf': 'Export to pdf',
  'plans.feature.ownLogo': 'Custom drawing logo',
  'plans.feature.collaboration': 'Online collaboration',
  'plans.feature.support247': 'Support 24/7',
  'plans.feature.noWatermark': 'No watermark',

  // QuickHelp
  'quickHelp.title': 'Quick guide {appName}',
  'quickHelp.readMorePre': 'Read the',
  'quickHelp.readMoreLink': 'user guide',
  'quickHelp.readMorePost': 'for a full user manual and guide.',
  'quickHelp.contact': 'Contact us at {contactEmail} with questions.',
  'quickHelp.toolsHeading': 'Tools',
  'quickHelp.panLabel': 'Pan',
  'quickHelp.panDesc':
    'Click and hold with the mouse, then drag. Shortcut: <kbd>SPACEBAR</kbd>.',
  'quickHelp.selectLabel': 'Select',
  'quickHelp.selectDesc':
    'Click an object to select it. Drag to move it. Drag the blue handles to edit. Shortcut: <kbd>V</kbd>.',
  'quickHelp.textLabel': 'Text',
  'quickHelp.textDesc':
    'Click to create text boxes. Select the text in the box and use the keyboard to edit it. Shortcut: <kbd>T</kbd>.',
  'quickHelp.lineLabel': 'Line',
  'quickHelp.lineDesc':
    'Click to add points. Hold <kbd>SHIFT</kbd> to lock the line to fixed angles. Press <kbd>ESCAPE</kbd> to finish. Shortcut: <kbd>L</kbd>.',
  'quickHelp.rectLabel': 'Rectangle',
  'quickHelp.rectDesc':
    'Click to place a rectangle with right-angle corners. Shortcut: <kbd>R</kbd>.',
  'quickHelp.dimensionLabel': 'Dimension',
  'quickHelp.dimensionDesc':
    'Mark dimensions on the drawing. Drawn like regular lines but styled for dimensioning. Shortcut: <kbd>M</kbd>.',
  'quickHelp.addLabel': 'Add',
  'quickHelp.addDesc':
    'Add doors, windows or drawing symbols. Click add and choose a symbol.',
  'quickHelp.actionsHeading': 'Common actions',
  'quickHelp.zoomHeading': 'Zoom',
  'quickHelp.zoomDesc':
    'Zoom by dragging the zoom handle in the bottom right corner. Or use <kbd>CTRL + Scroll wheel</kbd>. Or pinch on a laptop touchpad.',
  'quickHelp.deleteHeading': 'Delete element',
  'quickHelp.deleteDesc': 'Use: <kbd>BACKSPACE</kbd> or <kbd>DELETE</kbd>',
  'quickHelp.undoHeading': 'Undo',
  'quickHelp.undoDesc':
    'Use: <kbd>CTRL + Z</kbd> to undo. Use: <kbd>SHIFT + CTRL + Z</kbd> to redo.',
  'quickHelp.copyHeading': 'Copy',
  'quickHelp.copyDesc':
    'Use: <kbd>CTRL + C</kbd> to copy selected elements to clipboard. Use: <kbd>CTRL + V</kbd> to paste. Use: <kbd>CTRL + D</kbd> to duplicate in place.',
  'quickHelp.groupHeading': 'Group elements',
  'quickHelp.groupDesc':
    'Select 2 or more elements and use <kbd>CTRL + G</kbd> to group them. Use <kbd>SHIFT + CTRL + G</kbd> to ungroup. Double-click a group to edit its contents, press <kbd>ESC</kbd> to exit.',
  'quickHelp.snapLinesHeading': 'Snap lines',
  'quickHelp.snapLinesDesc':
    'Snap lines help position objects in line with each other. Disable snap lines by holding <kbd>CTRL</kbd> on Windows, or <kbd>CMD</kbd> on Mac. When adding new lines, hold <kbd>SHIFT</kbd> to lock to fixed angles. Show/hide all snap lines with <kbd>CMD</kbd>/<kbd>CTRL</kbd> + <kbd>SHIFT</kbd> + <kbd>O</kbd>.',
  'quickHelp.importMapHeading': 'Import map',
  'quickHelp.importMapDesc':
    'Click the import map button in the top left and upload your material. Remember to choose the same scale (e.g. 1:400) and format (e.g. A3 landscape) for the drawing and material.',
  'quickHelp.exportHeading': 'Export',
  'quickHelp.exportDesc':
    'Click the export button in the top right corner to download the drawing as a PDF.',
  'quickHelp.saveHeading': 'Save changes',
  'quickHelp.saveDesc':
    '{appName} saves all changes automatically. If your computer loses internet connection, {appName} will save changes locally in your browser until the connection is restored. To avoid losing work, make sure you have a stable internet connection.',

  // Admin
  'admin.projects.title': 'Projects',
  'admin.projects.total': 'Total projects: {count}',
  'admin.projects.loading': 'Loading projects...',
  'admin.pagination.prev': 'Previous',
  'admin.pagination.next': 'Next',
  'admin.pagination.pageOf': 'Page {page} of {totalPages}',
  'admin.projects.nameHeader': 'Name',
  'admin.projects.emailHeader': 'Email',
  'admin.projects.createdHeader': 'Created',
  'admin.projects.updatedHeader': 'Last updated',
  'admin.projects.changesCount': 'Changes',
  'admin.projects.actions': 'Actions',
  'admin.projects.noChangesToClear': 'No changes to clear',
  'admin.projects.clearChanges': 'Clear old changes',
  'admin.projects.fetchError': 'Something went wrong fetching projects',
  'admin.userProjects.title': 'Projects of {name}',
  'admin.userProjects.titleFallback': 'Projects of user',
  'admin.userProjects.total': 'Total projects: {count}',
  'admin.userProjects.site': 'Site: {site}',
  'admin.userProjects.loading': 'Loading projects...',
  'admin.userProjects.fetchError': 'Something went wrong fetching projects',
  'admin.userProjects.empty': 'This user has no projects.',
  'admin.garbageCollect.title': 'Clear old changes',
  'admin.garbageCollect.confirmText':
    'Are you sure you want to clear old changes for the project "{name}"?',
  'admin.garbageCollect.changesCount': 'This project has {count} changes.',
  'admin.garbageCollect.description':
    'Old versions and temporary changes will be removed, but the latest version of each element will be kept.',
  'admin.garbageCollect.warning': 'Note: This action cannot be undone.',
  'admin.garbageCollect.confirmButton': 'Yes, clear',
  'admin.garbageCollect.loadingButton': 'Clearing changes...',
  'admin.garbageCollect.successToast': '{message} ({count} changes cleared)',
  'admin.copyProject.title': 'Copy project',
  'admin.copyProject.description':
    'A copy of {name} will be created and assigned to the selected user.',
  'admin.copyProject.assignLabel': 'Assign copy to',
  'admin.copyProject.ownerOption': '{email} (owner)',
  'admin.copyProject.adminOption': '{email} (admin)',
  'admin.copyProject.copyButton': 'Copy',
  'admin.copyProject.copyingButton': 'Copying...',
  'admin.copyProject.cancelButton': 'Cancel',
  'admin.copyProject.successToast': 'Project copied',
  'admin.users.title': 'Users',
  'admin.users.total': 'Total users: {count}',
  'admin.users.actionHeader': 'Action',
  'admin.users.loading': 'Loading users...',
  'admin.users.fetchError': 'Something went wrong fetching users',
  'admin.users.deleteConfirm':
    'Are you sure you want to delete this user? This cannot be undone.',
  'admin.users.deleteError': 'Something went wrong deleting the user',
  'admin.users.nameHeader': 'Name',
  'admin.users.emailHeader': 'Email',
  'admin.users.siteHeader': 'Site',
  'admin.users.createdHeader': 'Created',
  'admin.users.lastActiveHeader': 'Last active',
  'admin.users.activeDaysHeader': 'Active days',
  'admin.users.subscriptionHeader': 'Subscription',
  'admin.users.deleteButton': 'Delete',
  'admin.users.statusActive': 'Active',
  'admin.users.statusCanceled': 'Canceled',
  'admin.users.statusIncomplete': 'Incomplete',
  'admin.users.statusIncompleteExpired': 'Incomplete expired',
  'admin.users.statusPastDue': 'Past due',
  'admin.users.statusTrialing': 'Trialing',
  'admin.users.statusUnpaid': 'Unpaid',
  'admin.users.statusPaused': 'Paused',
  'admin.users.subscriptionCancelAt': '(ends {date})',
  'admin.users.filterByStatus': 'Filter by subscription status',
  'admin.users.filterBySite': 'Filter by site',
  'admin.users.search': 'Search users',
  'admin.users.searchPlaceholder': 'Search name or email...',
  'admin.projects.filterByOwnerStatus': 'Owner subscription status',
  'admin.projects.filterByOwnerEmail': 'Owner email',
  'admin.projects.filterEmailPlaceholder': 'Search email...',
};

export default en;
